export type UpdateURLParam = {
	key: string;
	condition: boolean;
	value: string;
	newParams: URLSearchParams;
};

export const updateURLParam = ({ key, condition, value, newParams }: UpdateURLParam): void => {
	if (condition) {
		newParams.set(key, value);
	} else {
		newParams.delete(key);
	}
};
